import client from './client';
import type { Workspace, Post, SocialAccount, WorkspaceRole } from '../types';

type WorkspaceApiResponse = Omit<Workspace, 'ownerId'> & {
  owner_id: string;
  ownerId?: string;
};

const mapWorkspaceFromApi = (workspace: WorkspaceApiResponse): Workspace => {
  const ownerId = workspace.ownerId ?? workspace.owner_id;
  return {
    ...workspace,
    owner_id: workspace.owner_id ?? ownerId ?? '',
    ownerId,
  };
};

export const fetchUserWorkspaces = async (): Promise<Workspace[]> => {
  const response = await client.get<WorkspaceApiResponse[]>('/workspaces/');
  return response.data.map(mapWorkspaceFromApi);
};

export const checkWorkspaceNameAvailability = async (name: string): Promise<{ name_available: boolean }> => {
  const response = await client.get<{ name_available: boolean }>('/workspaces/availability', { params: { name } });
  return response.data;
};

export const createWorkspace = async (data: Partial<Workspace>): Promise<Workspace> => {
  const response = await client.post<WorkspaceApiResponse>('/workspaces/', data);
  return mapWorkspaceFromApi(response.data);
};

export const fetchWorkspacePosts = async (workspaceId: string): Promise<Post[]> => {
  const response = await client.get<Post[]>(`/workspaces/${workspaceId}/posts/`);
  return response.data;
};

export const createPost = async (workspaceId: string, post: Partial<Post>): Promise<Post> => {
  const response = await client.post<Post>(`/workspaces/${workspaceId}/posts/`, post);
  return response.data;
};

// Add other methods as needed: updatePost, deletePost, media operations...

// Accounts
export const createSocialAccount = async (workspaceId: string, account: Partial<SocialAccount>): Promise<SocialAccount> => {
    const response = await client.post<SocialAccount>(`/workspaces/${workspaceId}/accounts`, account);
    return response.data;
};

export const deleteAccount = async (workspaceId: string, accountId: string): Promise<void> => {
    await client.delete(`/workspaces/${workspaceId}/accounts/${accountId}`);
};

// Removed member management methods

// Workspace Management
export const renameWorkspace = async (workspaceId: string, name: string): Promise<void> => {
    await client.put(`/workspaces/${workspaceId}`, { name });
};

export const deleteWorkspace = async (workspaceId: string): Promise<void> => {
    await client.delete(`/workspaces/${workspaceId}`);
};

// Approvals (Stubbed for now, or future implementation)
export const createApprovalRequest = async (workspaceId: string, request: any): Promise<void> => {
    // console.warn('Approval requests API not fully implemented yet');
};

export const updateApprovalRequest = async (workspaceId: string, requestId: string, status: string): Promise<void> => {
     // console.warn('Approval requests API not fully implemented yet');
};
